// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default pink color for Rephrase and Cancel buttons */
.always-pink {
  background-color: #e91e63; /* Pink */
  color: white;
}

.always-pink:hover {
  background-color: #d81b60;
}

/* Pink color for Confirm button when enabled */
.enabled-pink {
  background-color: #e91e63; /* Pink */
  color: white;
}

/* Hover effect for Confirm button when enabled */
.enabled-pink:hover {
  background-color: #d81b60;
}

/* Darker pink when the Confirm button is clicked */
.enabled-pink:active {
  background-color: #c2185b; /* Darker pink */
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header h2 {
  margin: 0;
}

.dialog-header .close {
  background: none;
  border: none;
  font-size: 30px;
  color: black;
  cursor: pointer;
}

.selection-rephrase-dialog {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px 0 !important;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

.close-button {
  margin-left: 8px;
}

.dialog-content {
  overflow-y: auto;
  padding: 16px 24px !important;
}

.dialog-content > :first-child {
  margin-top: 0;
}

.dialog-content > :last-child {
  margin-bottom: 0;
}

.dialog-actions {
  position: sticky;
  bottom: 0;
  background: #fafafa;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 12px 24px;
  z-index: 2;
}

/* Normalize all action buttons */
.dialog-actions .mat-mdc-button-base {
  height: 40px;
  min-width: 120px;
  padding: 0 16px;
  margin: 6px;
  border-radius: 4px;
  border: 1px solid #ddd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.dialog-actions .mat-mdc-button-base .mdc-button__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  line-height: 1;
}

.dialog-actions .mat-mdc-button-base .mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}

/* Ensure disabled buttons keep same dimensions */
.dialog-actions .mat-mdc-button-base[disabled] {
  opacity: 0.6;
}

.cancel-btn {
  border: 1px solid #ddd;
  background-color: #f8f9fa;
  color: #444;
}

/* Existing pink theme */
.always-pink {
  background-color: #e91e63;
  color: #fff;
}

.always-pink:hover {
  background-color: #d81b60;
}

.enabled-pink {
  background-color: #e91e63;
  color: #fff;
}

.enabled-pink:hover {
  background-color: #d81b60;
}

.enabled-pink:active {
  background-color: #c2185b;
}

@media (max-width: 600px) {
  .dialog-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .dialog-actions .mat-mdc-button-base {
    width: 100%;
  }
  .dialog-content {
    padding: 12px 16px;
  }
  .dialog-header {
    padding: 12px 16px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/selection-rephraseAi-dialog/selection-rephraseAi-dialog.component.scss"],"names":[],"mappings":"AAAA,uDAAA;AACA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA,+CAAA;AACA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AACF;;AAEA,iDAAA;AACA;EACE,yBAAA;AACF;;AAEA,mDAAA;AACA;EACE,yBAAA,EAAA,gBAAA;AACF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAEF;;AACA,iCAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAEF;;AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAGF;;AADA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAIF;;AADA,iDAAA;AACA;EACE,YAAA;AAIF;;AADA;EACE,sBAAA;EACA,yBAAA;EACA,WAAA;AAIF;;AADA,wBAAA;AACA;EACE,yBAAA;EACA,WAAA;AAIF;;AAFA;EACE,yBAAA;AAKF;;AAHA;EACE,yBAAA;EACA,WAAA;AAMF;;AAJA;EACE,yBAAA;AAOF;;AALA;EACE,yBAAA;AAQF;;AALA;EACE;IACE,sBAAA;IACA,oBAAA;EAQF;EANA;IACE,WAAA;EAQF;EANA;IACE,kBAAA;EAQF;EANA;IACE,oBAAA;EAQF;AACF","sourcesContent":["/* Default pink color for Rephrase and Cancel buttons */\n.always-pink {\n  background-color: #e91e63; /* Pink */\n  color: white;\n}\n\n.always-pink:hover {\n  background-color: #d81b60;\n}\n\n/* Pink color for Confirm button when enabled */\n.enabled-pink {\n  background-color: #e91e63; /* Pink */\n  color: white;\n}\n\n/* Hover effect for Confirm button when enabled */\n.enabled-pink:hover {\n  background-color: #d81b60;\n}\n\n/* Darker pink when the Confirm button is clicked */\n.enabled-pink:active {\n  background-color: #c2185b; /* Darker pink */\n}\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  // margin-bottom: 10px;\n}\n\n.dialog-header h2 {\n  margin: 0;\n}\n\n.dialog-header .close {\n  background: none;\n  border: none;\n  font-size: 30px;\n  color: black;\n  cursor: pointer;\n}\n\n.selection-rephrase-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px 0 !important;\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 2;\n}\n\n.close-button {\n  margin-left: 8px;\n}\n\n.dialog-content {\n  overflow-y: auto;\n  padding: 16px 24px !important;\n}\n\n.dialog-content > :first-child {\n  margin-top: 0;\n}\n.dialog-content > :last-child {\n  margin-bottom: 0;\n}\n\n.dialog-actions {\n  position: sticky;\n  bottom: 0;\n  background: #fafafa;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 24px;\n  z-index: 2;\n}\n\n/* Normalize all action buttons */\n.dialog-actions .mat-mdc-button-base {\n  height: 40px;\n  min-width: 120px;\n  padding: 0 16px;\n  margin: 6px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n.dialog-actions .mat-mdc-button-base .mdc-button__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1;\n}\n.dialog-actions .mat-mdc-button-base .mat-icon {\n  font-size: 20px;\n  height: 20px;\n  width: 20px;\n}\n\n/* Ensure disabled buttons keep same dimensions */\n.dialog-actions .mat-mdc-button-base[disabled] {\n  opacity: 0.6;\n}\n\n.cancel-btn {\n  border: 1px solid #ddd;\n  background-color: #f8f9fa;\n  color: #444;\n}\n\n/* Existing pink theme */\n.always-pink {\n  background-color: #e91e63;\n  color: #fff;\n}\n.always-pink:hover {\n  background-color: #d81b60;\n}\n.enabled-pink {\n  background-color: #e91e63;\n  color: #fff;\n}\n.enabled-pink:hover {\n  background-color: #d81b60;\n}\n.enabled-pink:active {\n  background-color: #c2185b;\n}\n\n@media (max-width: 600px) {\n  .dialog-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .dialog-actions .mat-mdc-button-base {\n    width: 100%;\n  }\n  .dialog-content {\n    padding: 12px 16px;\n  }\n  .dialog-header {\n    padding: 12px 16px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
